import { initializeApp } from "firebase/app"
import {initializeFirestore ,connectFirestoreEmulator } from "firebase/firestore"
import { getStorage, connectStorageEmulator } from "firebase/storage"
import { getAuth, connectAuthEmulator  } from "firebase/auth"
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"
import { getRemoteConfig } from "firebase/remote-config"
import { firebaseConfig } from "@/config/project"
import { version } from '../../package.json'
const firebaseApp = initializeApp(firebaseConfig);

if(process.env.NODE_ENV !== 'development' && window.location.hostname.indexOf('--preview-') < 0){
  console.log = () => {void(0)}
  console.trace = () => {void(0)}
  console.table = () => {void(0)}
} 

console.trace = () => {void(0)}

export const auth = getAuth(firebaseApp)
export const db = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: ('Cypress' in window) ? true : false,
})
export const storage = getStorage(firebaseApp)
export const functions = getFunctions(firebaseApp,'asia-northeast1')
export const remoteConfig = getRemoteConfig(firebaseApp)
remoteConfig.defaultConfig = {
  version: version
}

remoteConfig.settings.minimumFetchIntervalMillis = 600 * 1000

export let useEmulator = false

if(window.location.hostname === 'localhost' && window.location.port === '8081'){
  remoteConfig.settings.minimumFetchIntervalMillis = 60 * 1000
  connectAuthEmulator(auth, "http://localhost:9099")
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectStorageEmulator(storage, "localhost", 9199)
  connectFunctionsEmulator(functions, "localhost", 5001)
  useEmulator = true
}

export const appVersion = version

//export const  = firebase.auth;
//export const firestore = firebase.firestore;
